import {
  DEFAULT_VAPI_AGENT_ID,
  LEGACY_DEFAULT_VOICE_ID,
} from '../../constants/voiceDefaults';

const VAPI_BASE_URL = 'https://api.vapi.ai';

function getVapiApiKey() {
  return import.meta.env.VITE_VAPI_API_KEY;
}

export async function getAssistantById(assistantId) {
  const apiKey = getVapiApiKey();
  if (!apiKey) {
    throw new Error('VITE_VAPI_API_KEY is not configured');
  }

  const response = await fetch(`${VAPI_BASE_URL}/assistant/${assistantId}`, {
    headers: {
      Authorization: `Bearer ${apiKey}`,
    },
  });

  if (!response.ok) {
    const body = await response.text();
    throw new Error(`Vapi API error ${response.status}: ${body}`);
  }

  return response.json();
}

export async function getVoiceIdFromAssistant(assistantId) {
  const assistant = await getAssistantById(assistantId);
  const voiceId = assistant.voice?.voiceId;

  if (!voiceId) {
    throw new Error(`No voiceId found for assistant ${assistantId}`);
  }

  return voiceId;
}

export function shouldSyncVoiceProfile(profile) {
  if (!profile) return false;
  if (!profile.vapi_agent_id) return true;
  if (!profile.voice_id || profile.voice_id === LEGACY_DEFAULT_VOICE_ID) return true;
  return false;
}

export async function buildVoiceProfileUpdates(profile) {
  const vapiAgentId = profile.vapi_agent_id || DEFAULT_VAPI_AGENT_ID;
  const voiceId = await getVoiceIdFromAssistant(vapiAgentId);
  const updates = { voice_id: voiceId };

  if (!profile.vapi_agent_id) {
    updates.vapi_agent_id = DEFAULT_VAPI_AGENT_ID;
  }

  if (updates.voice_id === profile.voice_id && !updates.vapi_agent_id) {
    return null;
  }

  return updates;
}

export async function resolveVoiceIdsFromAssistants(assistantIds) {
  return Promise.allSettled(
    assistantIds.map(async (assistantId) => {
      const assistant = await getAssistantById(assistantId);

      return {
        assistantId,
        assistantName: assistant.name ?? null,
        voiceProvider: assistant.voice?.provider ?? null,
        voiceId: assistant.voice?.voiceId ?? null,
        voice: assistant.voice ?? null,
      };
    })
  );
}
